import { render, staticRenderFns } from "./tableAttachment.vue?vue&type=template&id=556e9627&"
import script from "./tableAttachment.js?vue&type=script&lang=js&"
export * from "./tableAttachment.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports